var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyElementBase } from "./reactquestion_element";
import { SurveyRow } from "./row";
var SurveyPanelBase = /** @class */ (function (_super) {
    __extends(SurveyPanelBase, _super);
    function SurveyPanelBase(props) {
        var _this = _super.call(this, props) || this;
        _this.rootRef = React.createRef();
        return _this;
    }
    SurveyPanelBase.prototype.getStateElement = function () {
        return this.panelBase;
    };
    SurveyPanelBase.prototype.canUsePropInState = function (key) {
        return key !== "elements" && _super.prototype.canUsePropInState.call(this, key);
    };
    Object.defineProperty(SurveyPanelBase.prototype, "survey", {
        get: function () {
            return this.getSurvey();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyPanelBase.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyPanelBase.prototype, "css", {
        get: function () {
            return this.getCss();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyPanelBase.prototype, "panelBase", {
        get: function () {
            return this.getPanelBase();
        },
        enumerable: false,
        configurable: true
    });
    SurveyPanelBase.prototype.getPanelBase = function () {
        return this.props.element || this.props.question;
    };
    SurveyPanelBase.prototype.getSurvey = function () {
        return (this.props.survey || (!!this.panelBase ? this.panelBase.survey : null));
    };
    SurveyPanelBase.prototype.getCss = function () {
        return this.props.css;
    };
    SurveyPanelBase.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.doAfterRender();
    };
    SurveyPanelBase.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        var el = this.rootRef.current;
        if (!!el) {
            el.removeAttribute("data-rendered");
        }
    };
    SurveyPanelBase.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        if (!!prevProps.page &&
            !!this.survey &&
            !!this.survey.activePage &&
            prevProps.page.id === this.survey.activePage.id)
            return;
        this.doAfterRender();
    };
    SurveyPanelBase.prototype.doAfterRender = function () {
        var el = this.rootRef.current;
        if (el && this.survey) {
            if (this.panelBase.isPanel) {
                this.panelBase.afterRender(el);
            }
            else {
                this.survey.afterRenderPage(el);
            }
        }
    };
    SurveyPanelBase.prototype.getIsVisible = function () {
        return this.panelBase.isVisible;
    };
    SurveyPanelBase.prototype.canRender = function () {
        return (_super.prototype.canRender.call(this) && !!this.survey && !!this.panelBase && !!this.panelBase.survey && this.getIsVisible());
    };
    SurveyPanelBase.prototype.renderRows = function (css) {
        var _this = this;
        return this.panelBase.visibleRows.map(function (row) { return _this.createRow(row, css); });
    };
    SurveyPanelBase.prototype.createRow = function (row, css) {
        return (React.createElement(SurveyRow, { key: row.id, row: row, survey: this.survey, creator: this.creator, css: css }));
    };
    return SurveyPanelBase;
}(SurveyElementBase));
export { SurveyPanelBase };
